var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('k-chip',{staticClass:"cloudrec-chip",attrs:{"size":"xs","color":_vm.color},on:{"click":_vm.open}},[_c('k-icon',{attrs:{"small":""}},[_vm._v("file_download")]),_vm._v(" "+_vm._s(_vm.title)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }